import { ApiRequestObservable } from 'framework/api';
import { ExportFormatOption } from "./types";



export function getExportFormats() {
	return new ApiRequestObservable<ExportFormatOption[]>({
		url: 'dataSources/exportFormats',
		method: 'GET',
		accountBased: true
	});
}

export function exportDataSourceWidget(args: { format: string, payload: Array<object> }) {
	return new ApiRequestObservable<string>({
		url: `dataSources/export${args.format}`,
		method: 'POST',
		accountBased: true,
		payload: args.payload
	});
}
